import { useTranslation } from 'react-i18next'


import { BannerApp } from '@widgets/app-banner'

import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function AboutPage () {
  const { t: ta } = useTranslation('about')
  const { t: ts } = useTranslation('seo')

  return (
    <Container>
      <SEO
        title={ts('about.title', { brand: BRAND_NAME })}
        description={ts('about.description', { brand: BRAND_NAME })}
      />
      <Wrapper className={styles.wrapper}>
        <div className={styles.header}>
          <Breadcrumbs
            className={styles.breadcrumbs}
            links={[
              {
                title: ta('page'),
              },
            ]}
          />
          <h1 className={styles.title}>{ta('content.title')}</h1>
        </div>

        <div className={styles.content}>
          {/* Jetkizedi Section */}
          <section className={styles.section}>
            <div className={styles.jetkizedi}>
              <div className={styles.jetkizedi__image}>
                <img src="/img/about/jetkizedi-banner.jpg" alt="ANVAR JETKIZEDI" />
              </div>
              <div className={styles.jetkizedi__content}>
                <h2 className={styles.jetkizedi__title}>
                  {ta('content.jetkizedi.title')}
                </h2>
                <p className={styles.jetkizedi__description}>
                  {ta('content.jetkizedi.description1')}
                </p>
                <p className={styles.jetkizedi__description}>
                  {ta('content.jetkizedi.description2')}
                </p>
                <p className={styles.jetkizedi__description}>
                  {ta('content.jetkizedi.description3')}
                </p>
                <div className={styles.jetkizedi__goal}>
                  <h3 className={styles.jetkizedi__goalTitle}>
                    {ta('content.jetkizedi.goalTitle')}
                  </h3>
                  <p className={styles.jetkizedi__goalText}>
                    {ta('content.jetkizedi.goalText')}
                  </p>
                </div>
                <p className={styles.jetkizedi__slogan}>
                  {ta('content.jetkizedi.slogan')}
                </p>
              </div>
            </div>
          </section>

          {/* Hero Section */}
          <section className={styles.section}>
            <div className={styles.hero}>
              <div className={styles.hero__content}>
                <h2 className={styles.hero__title}>
                  {ta('content.hero.title')}
                </h2>
                <p className={styles.hero__description}>
                  {ta('content.hero.description')}
                </p>
                <div className={styles.stats}>
                  <div className={styles.stats__item}>
                    <div className={styles.stats__value}>48+</div>
                    <div className={styles.stats__label}>
                      {ta('content.hero.stats.stores')}
                    </div>
                  </div>
                  <div className={styles.stats__item}>
                    <div className={styles.stats__value}>
                      {'>'}20 млн.
                    </div>
                    <div className={styles.stats__label}>
                      {ta('content.hero.stats.customers')}
                    </div>
                  </div>
                  <div className={styles.stats__item}>
                    <div className={styles.stats__value}>70%</div>
                    <div className={styles.stats__label}>
                      {ta('content.hero.stats.kazakhstan')}
                    </div>
                  </div>
                  <div className={styles.stats__item}>
                    <div className={styles.stats__value}>
                      {'>'}25 тыс.
                    </div>
                    <div className={styles.stats__label}>
                      {ta('content.hero.stats.products')}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.hero__image}>
                <img src="/img/about/hero-image.png" alt="" />
              </div>
            </div>
          </section>

          {/* History Section */}
          <section className={styles.section}>
            <div className={styles.history}>
              <div className={styles.history__image}>
                <img src="/img/about/history-image.jpg" alt="" />
              </div>
              <div className={styles.history__content}>
                <h2 className={styles.history__title}>
                  {ta('content.history.title')}
                </h2>
                <p className={styles.history__description}>
                  {ta('content.history.description')}
                </p>
                <div className={styles.stats}>
                  <div className={styles.stats__item}>
                    <div className={styles.stats__value}>30+</div>
                    <div className={styles.stats__label}>
                      {ta('content.history.stats.years')}
                    </div>
                  </div>
                  <div className={styles.stats__item}>
                    <div className={styles.stats__value}>
                      {'>'}75 тыс. м<sup>2</sup>
                    </div>
                    <div className={styles.stats__label}>
                      {ta('content.history.stats.area')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Locations Section */}
          {/* <section className={styles.section}>
            <div className={styles.locations}>
              <div className={styles.locations__map}>
                <img src="/img/about/map.svg" alt="" />
              </div>
              <div className={styles.locations__content}>
                <h2 className={styles.locations__title}>
                  {ta('content.locations.title')}
                </h2>
                <p className={styles.locations__description}>
                  {ta('content.locations.description')}
                </p>
                <Button
                  className={styles.locations__button}
                  theme="primary"
                  size="large"
                >
                  {ta('content.locations.button')}
                </Button>
              </div>
            </div>
          </section> */}

          {/* Advantages Section */}
          <section className={styles.section}>
            <h2 className={styles.advantages__title}>
              {ta('content.advantages.title')}
            </h2>
            <div className={styles.advantages}>
              {[ 3, 4, 1, 2, 5, 6 ].map((num) => (
                <div key={num} className={styles.advantage}>
                  <div className={styles.advantage__icon}>
                    <img
                      src={`/img/about/advantages/advantage-${num}.svg`}
                      alt=""
                    />
                  </div>
                  <h3 className={styles.advantage__title}>
                    {ta(`content.advantages.${num}.title`)}
                  </h3>
                  <p className={styles.advantage__description}>
                    {ta(`content.advantages.${num}.description`)}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Mission Section */}
          <section className={styles.section}>
            <div className={styles.mission}>
              <div className={styles.mission__left}>
                <h2 className={styles.mission__title}>
                  {ta('content.mission.title')}
                </h2>
                <div className={styles.mission__stat}>
                  <span className={styles.mission__statValue}>
                    {'>'}20 млн.
                  </span>
                  <span className={styles.mission__statLabel}>
                    {ta('content.mission.stat')}
                  </span>
                </div>
              </div>
              <p className={styles.mission__description}>
                {ta('content.mission.description')}
              </p>
            </div>
          </section>

          {/* Services Section */}
          {/* <div className={styles.block}>
            <Services />
          </div> */}

          {/* Feedback Section */}
          {/* <div className={styles.block}>
            <Feedback />
          </div> */}

          {/* Banner Section */}
          <div className={styles.block}>
            <BannerApp />
          </div>
        </div>
      </Wrapper>
    </Container>
  )
}
